export default "__VITE_ASSET__D_XiDqF4__"